import { UserManagementState } from './types';

export const userManagementInitialState: UserManagementState = {
  users: [],
  isAutoApprovalDisabled: false,
  visual: {
    isFetchingUsers: false,
    isFetchingAutoApprovalState: false,
  },
};
